export class EstadoCivil {
  Valor: string;
  DescricaoMasc: string;
  DescricaoFem: string;

  constructor(valor: string, DescricaoMasc: string, DescricaoFem?: string) {
    this.Valor = valor;
    this.DescricaoMasc = DescricaoMasc;
    this.DescricaoFem = DescricaoFem ? DescricaoFem : DescricaoMasc;
  }
}
